export enum PaymentOptions {
  CASH = "CASH",
  CREDIT = "CREDIT",
  CHEQUE = "CHEQUE",
  BANK_TRANSFER = "BANK_TRANSFER",
  CARD_PAYMENT = "CARD_PAYMENT",
  CASH_ON_DELIVERY = "CASH_ON_DELIVERY",
  QR_PAYMENT = "QR_PAYMENT",
  DIGITAL_PAYMENT = "DIGITAL_PAYMENT"
}